export const filtersMutationKeys = {
  CREATE_FILTER: 'create_filter'
}
